import restApi from "@plannel/services/utils/rest-api";
import ResponseUtil from "@plannel/pages/utils/response-util";

const user = JSON.parse(localStorage.getItem("user"));
const getAll = (params) => {
  return restApi.post("/api/demandval", params);
};

const upsertScenario = data => {
  return restApi.post("/api/demandval/scenario/upsert", data);
};

const upsertScenarioBulk = data => {
  return restApi.post("/api/demandval/scenario/bulk/upsert", data);
};

const importAll = (formData) => {
  return restApi.post('/api/demandval/import-excel', formData);
};

const excelAllForEdit = (params) => {
  return fetch("/api/demandval/excel-for-edit", {
    body: ResponseUtil.getExportParamsForPost(params),
    method: "POST",
    headers: {
      "Content-type": "application/json",
      "x-tenant-id": user.tenantId,
      Authorization: `${user.type} ${user.accessToken}`,
      "x-module-name": "DP"
    }
  }).then(response => {
    // 202 Accepted: 비동기 export → 알림 빠른 폴링 시작
    if (response.status === 202) {
      window.dispatchEvent(new CustomEvent('export-started'));
    }
    return response;
  });
};

const demandByItem = ( params ) => {
  return restApi.get("/api/demandval/item", { params });
};

const phaseByItem = data => {
  return restApi.post("/api/demandval/phase", data);
};

const aggregation = (params) => {
  return restApi.get("/api/demandval/aggregation", { params });
};

const archive = () => {
  return restApi.get("/api/demandval/archive-data");
};

const makeObjVal = (params) => {
  return restApi.get("/api/demandval/make-objVal-data", { params });
};

const demandValService = {
  getAll,
  upsertScenario,
  upsertScenarioBulk,
  excelAllForEdit,
  importAll,
  demandByItem,
  phaseByItem,
  aggregation,
  archive,
  makeObjVal
};

export default demandValService;